import { Feature } from '@/pinia/feature'

export const files: Feature = {
  name: 'files',
  enabled: true,
  access: [
    'FEAT_ATTACHMENT_ADMIN',
    'FEAT_ATTACHMENT_CREATOR',
    'FEAT_ATTACHMENT_EDITOR',
    'FEAT_ATTACHMENT_READER'
  ],
  title: {
    en: 'Files',
    sv: 'Filer'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconPaperclip',
    disableIsDrawPointActive: true,
    enableFullscreen: true,
    size: 'large',
    subtitle: {
      sv: 'Filer',
      en: 'Files'
    }
  },
  children: [
    {
      title: {
        en: 'Files',
        sv: 'Filer'
      },
      name: 'files',
      enabled: true,
      children: [
        {
          name: 'files',
          enabled: true,
          title: {
            en: 'Files',
            sv: 'Filer'
          },
          component: 'FileDirectoryDashboard',
          isRoute: true,
          props: {
            icon: 'IconPaperclip'
          },
          children: []
        }
      ]
    }
  ]
}
